/**
 * DEC-001: Initialize view registry with seed data
 * 
 * Called at app startup to bootstrap view registry.
 * Later, this will load views from API/DB instead.
 * 
 * NOTE: This is idempotent - safe to call multiple times (e.g., in React strict mode).
 */

import { viewRegistry } from './registry';
import { itemShopifyView } from './seed/itemShopifyView';
import { salesOrderShopifyEcomView } from './seed/salesOrderShopifyView';
import { stockEntryShopifyView } from './seed/stockEntryShopifyView';
import { itemPriceShopifyView } from './seed/itemPriceShopifyView';
import { pricingRuleShopifyView } from './seed/pricingRuleShopifyView';
import { storefrontThemeShopifyView } from './seed/storefrontThemeShopifyView';
import { storefrontPageConfigShopifyView } from './seed/storefrontPageConfigShopifyView';
import { itemGroupShopifyView } from './seed/itemGroupShopifyView';
import { customerShopifyView } from './seed/customerShopifyView';

let initialized = false;

export function initializeViewRegistry() {
  if (initialized) {
    return; // Already initialized
  }
  
  // Register Item views
  viewRegistry.registerViews('Item', [itemShopifyView]);
  
  // Register Sales Order views
  viewRegistry.registerViews('Sales Order', [salesOrderShopifyEcomView]);
  
  // Register Stock Entry views
  viewRegistry.registerViews('Stock Entry', [stockEntryShopifyView]);
  
  // Register Item Price views
  viewRegistry.registerViews('Item Price', [itemPriceShopifyView]);
  
  // Register Pricing Rule views
  viewRegistry.registerViews('Pricing Rule', [pricingRuleShopifyView]);
  
  // Register Storefront Theme views
  viewRegistry.registerViews('Storefront Theme', [storefrontThemeShopifyView]);
  
  // Register Storefront Page Config views
  viewRegistry.registerViews('Storefront Page Config', [storefrontPageConfigShopifyView]);

  // Register Item Group views
  viewRegistry.registerViews('Item Group', [itemGroupShopifyView]);

  // Register Customer views
  viewRegistry.registerViews('Customer', [customerShopifyView]);

  initialized = true;
}

